import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SendLogin } from "../redux/auth";
import { useSelector, useDispatch } from "react-redux";

const LogActivity = () => {
  const auth = useSelector((state) => state.auth);
  const location = useLocation();
  let isSessionActive = false;
  const isAuthenticated = auth.authenticated || false;
  const dispatch = useDispatch();

  const invokeLoginApi = () => {
    isSessionActive = sessionStorage.getItem("userActivityLog") || false;
    if (!isSessionActive && isAuthenticated) {
      dispatch(SendLogin());
      sessionStorage.setItem("userActivityLog", true);
    }
  };

  useEffect(() => {
    invokeLoginApi();
  }, [location.pathname, isAuthenticated]);

  return null;
};

export default LogActivity;
